import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Building2, Heart } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const navItems = [
    { name: 'Beskæftigelsen - hvem er vi', path: '/beskaeftigelsen' },
    { name: 'Paragraf 103', path: '/paragraf-103' },
    { name: 'Målgruppe', path: '/maalgruppe' },
    { name: 'Aktivitetstilbud', path: '/aktivitetstilbud' },
    { name: 'Kerneværdier', path: '/vaerdigrundlag' },
    { name: 'Pædagogik', path: '/paedagogik' },
    { name: 'STU', path: '/stu' },
    { name: 'Billeder', path: '/billeder' },
    { name: 'Kontakt', path: '/kontakt' },
  ];

  return (
    <footer className="bg-stone-900 text-stone-300 border-t border-stone-800">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand Column */}
          <div className="space-y-4">
            <Link to="/" className="flex flex-col">
              <span className="text-2xl font-bold tracking-tight text-white">
                LIVSLYST
              </span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-stone-400 font-medium -mt-1">
                ApS · Pædagogisk Enhed
              </span>
            </Link>
            <p className="text-stone-400 text-sm max-w-sm leading-relaxed">
              Et trygt og udviklende tilbud om privat beskyttet beskæftigelse efter §103. Vi har fokus på menneskelighed, tryghed, nærvær og positiv udvikling.
            </p>
            <div className="flex items-center gap-1.5 text-xs text-stone-500">
              <Building2 className="w-3.5 h-3.5 text-emerald-500" />
              <span>CVR-nr: <span className="whitespace-nowrap">32336302</span></span>
            </div>
          </div>

          {/* Navigation Column */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider">
              Navigation
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="hover:text-emerald-400 transition-colors">
                  Forside
                </Link>
              </li>
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="hover:text-emerald-400 transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider">
              Kontaktoplysninger
            </h3>
            <ul className="space-y-3.5 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" />
                <span className="text-stone-300 leading-relaxed">
                  Surhavevej 14 A,<br />
                  6650 Brørup
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-emerald-500 shrink-0" />
                <a 
                  href="tel:51504654" 
                  className="hover:text-emerald-400 transition-colors whitespace-nowrap"
                >
                  51 50 46 54
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-emerald-500 shrink-0" />
                <a 
                  href="mailto:Kontakt@livslystaps.dk" 
                  className="hover:text-emerald-400 transition-colors whitespace-nowrap"
                >
                  Kontakt@livslystaps.dk
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-stone-950 text-stone-500 text-xs py-6 border-t border-stone-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p>© {currentYear} LIVSLYST ApS. Alle rettigheder forbeholdes.</p>
          <p className="flex items-center gap-1">
            <span>Udviklet med</span>
            <Heart className="w-3.5 h-3.5 text-emerald-500 fill-emerald-500" />
            <span>for tryghed og trivsel</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
